import type { LayoutItem } from "react-grid-layout";

import type { TileLocation } from "../../../../api/types/dashboardsTypes.ts";

export const convertTileLocationToLayout = (tileLocation: TileLocation, tileId: string): LayoutItem => {
  return {
    i: tileId,
    x: tileLocation.column,
    y: tileLocation.row,
    w: tileLocation.width,
    h: tileLocation.height,
    isDraggable: tileLocation.isDraggable,
    isResizable: tileLocation.isResizable,
    static: tileLocation.isStatic,
  };
};
